// src/components/KakaoChatButton.js
import { useEffect } from "react";

const KakaoChatButton = () => {
  useEffect(() => {
    // SDK 스크립트가 없으면 추가
    if (!window.Kakao) {
      const script = document.createElement("script");
      script.src = "https://t1.kakaocdn.net/kakao_js_sdk/2.7.5/kakao.min.js";
      script.integrity = "sha384-dok87au0gKqJdxs7msEdBPNnKSRT+/mhTVzq+qOhcL464zXwvcrpjeWvyj1kCdq6";
      script.crossOrigin = "anonymous";
      script.async = true;
      script.onload = () => {
        if (!window.Kakao.isInitialized()) {
          window.Kakao.init("de78b1eb0297a5ecc6cbbd0a2f6331bb"); // ✅ 자바스크립트 키 입력
        }
      };
      document.head.appendChild(script);
    } else {
      if (!window.Kakao.isInitialized()) {
        window.Kakao.init("de78b1eb0297a5ecc6cbbd0a2f6331bb"); // ✅ 자바스크립트 키 입력
      }
    }
  }, []);

  const openChat = () => {
    if (window.Kakao && window.Kakao.Channel) {
      window.Kakao.Channel.chat({
        channelPublicId: "_YGEan", // ✅ 본인의 채널 ID
      });
    }
  };

  return (
    <button onClick={openChat}>
      <img
        src="https://developers.kakao.com/tool/resource/static/img/button/channel/consult/consult_small_yellow_pc.png"
        alt="카카오톡 채널 채팅하기 버튼"
      />
    </button>
  );
};

export default KakaoChatButton;
